import { render } from "./BreadCrumb.vue?vue&type=template&id=198b29d8&scoped=true&ts=true"
import script from "./BreadCrumb.vue?vue&type=script&lang=ts"
export * from "./BreadCrumb.vue?vue&type=script&lang=ts"

import "./BreadCrumb.vue?vue&type=style&index=0&id=198b29d8&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-198b29d8"]])

export default __exports__